export default {
  state: {
    loading: false,
    loadingMessage: undefined
  },
  getters: {
  },
  // 同步方法
  mutations: {
    showLoading (state, message) {
      state.loading = true
      state.loadingMessage = message
    },
    closeLoading (state) {
      state.loading = false
      state.loadingMessage = undefined
    }
  },
  // 异步方法
  actions: {
  }
}
